import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";
import { Button } from "@website/ui/button";
import { Loading } from "@website/ui/loading";
import { TextField } from "@website/ui/text-field";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { Header } from "@website/widget/login/components";
import styles from "@website/widget/login/components/phone-number-card/phone-number-card.module.scss";
import { PhoneNumberCardPropertiesType } from "@website/widget/login/components/phone-number-card/phone-number-card.types";
import { usePhoneNumberCard } from "@website/widget/login/components/phone-number-card/use-phone-number-card";
import { FC, FormEvent } from "react";
export const PhoneNumberCard: FC<PhoneNumberCardPropertiesType> = properties => {
  const $ = _c(49);
  const {
    onClose,
    isWelcomeScreen,
    isForceLogin
  } = properties;
  const {
    phoneNumber,
    onChangePhoneNumber,
    onSubmitPhoneNumber,
    isLoading,
    error,
    headerTitle,
    modalTitle,
    loginBack,
    backButtonText
  } = usePhoneNumberCard(properties);
  let t0;
  if ($[0] !== isWelcomeScreen || $[1] !== onClose) {
    t0 = function _onClose() {
      if (isWelcomeScreen) {
        addEventToTracking(USER_TRACKING_EVENTS.APP_WELCOME_SCREEN_DISMISSED, {
          product: "core"
        });
      }
      onClose?.();
    };
    $[0] = isWelcomeScreen;
    $[1] = onClose;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const _onClose = t0;
  let t1;
  if ($[3] !== isWelcomeScreen || $[4] !== onClose) {
    t1 = function _skipWelcomeScreen() {
      if (isWelcomeScreen) {
        addEventToTracking(USER_TRACKING_EVENTS.APP_WELCOME_SCREEN_SKIP_CLICKED, {
          product: "core"
        });
      }
      onClose?.();
    };
    $[3] = isWelcomeScreen;
    $[4] = onClose;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const _skipWelcomeScreen = t1;
  let t2;
  if ($[6] !== isLoading || $[7] !== isWelcomeScreen || $[8] !== onSubmitPhoneNumber) {
    t2 = function _onSubmit(_event) {
      if (!isLoading) {
        if (isWelcomeScreen) {
          addEventToTracking(USER_TRACKING_EVENTS.APP_WELCOME_SCREEN_SKIP_CLICKED, {
            product: "core"
          });
        }
        onSubmitPhoneNumber(_event);
      }
    };
    $[6] = isLoading;
    $[7] = isWelcomeScreen;
    $[8] = onSubmitPhoneNumber;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const _onSubmit = t2;
  const t3 = onClose ? _onClose : undefined;
  let t4;
  if ($[10] !== headerTitle || $[11] !== t3) {
    t4 = <Header title={headerTitle} onClose={t3} />;
    $[10] = headerTitle;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== modalTitle) {
    t5 = <div className={styles.title}>{modalTitle}</div>;
    $[13] = modalTitle;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <MaterialIcon name="phone_iphone" />;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const t7 = Boolean(error);
  let t8;
  if ($[16] !== error || $[17] !== onChangePhoneNumber || $[18] !== phoneNumber || $[19] !== t7) {
    t8 = <div className={styles.input}><TextField StartIcon={t6} error={t7} fullWidth={true} helperText={error} onChange={onChangePhoneNumber} placeholder={"\u0634\u0645\u0627\u0631\u0647 \u0645\u0648\u0628\u0627\u06CC\u0644"} value={phoneNumber} autoFocus={true} inputMode="numeric" type="text" /></div>;
    $[16] = error;
    $[17] = onChangePhoneNumber;
    $[18] = phoneNumber;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== isWelcomeScreen) {
    t9 = !isWelcomeScreen && <div className={styles.info}><span className={styles["info-icon"]}><MaterialIcon name="info" variant="outlined" /></span>ورود و استفاده از {replaceSnappTripBasedOnChannel("\u0627\u0633\u0646\u067E\u200C\u062A\u0631\u06CC\u067E")} به معنای پذیرش<a className={styles["info-rules"]} href="/policy">قوانین و مقررات</a>آن می باشد.</div>;
    $[21] = isWelcomeScreen;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== _skipWelcomeScreen || $[24] !== isWelcomeScreen) {
    t10 = isWelcomeScreen && <Button fullWidth={true} size="large" color="secondary" variant="text" type="button" text={"\u0627\u062F\u0627\u0645\u0647 \u0628\u062F\u0648\u0646 \u0648\u0631\u0648\u062F"} onClick={_skipWelcomeScreen} />;
    $[23] = _skipWelcomeScreen;
    $[24] = isWelcomeScreen;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== isLoading) {
    t11 = isLoading ? <Loading color="white" size="lg" /> : "\u062A\u0627\u06CC\u06CC\u062F \u0648 \u0627\u062F\u0627\u0645\u0647";
    $[26] = isLoading;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11) {
    t12 = <Button color="secondary" fullWidth={true} size="large" type="submit" variant="contained">{t11}</Button>;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t10 || $[31] !== t12) {
    t13 = <div className="flex flex-row justify-between gap-2">{t10}{t12}</div>;
    $[30] = t10;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== backButtonText || $[34] !== isForceLogin || $[35] !== loginBack) {
    t14 = isForceLogin && <Button color="secondary" fullWidth={true} onClick={loginBack} size="large" type="button" variant="outline">{backButtonText}</Button>;
    $[33] = backButtonText;
    $[34] = isForceLogin;
    $[35] = loginBack;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t13 || $[38] !== t14) {
    t15 = <div className={styles.footer}>{t13}{t14}</div>;
    $[37] = t13;
    $[38] = t14;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== _onSubmit || $[41] !== t15 || $[42] !== t8 || $[43] !== t9) {
    t16 = <form className="w-full" onSubmit={_onSubmit}>{t8}{t9}{t15}</form>;
    $[40] = _onSubmit;
    $[41] = t15;
    $[42] = t8;
    $[43] = t9;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] !== t16 || $[46] !== t4 || $[47] !== t5) {
    t17 = <div className={styles.container}>{t4}{t5}{t16}</div>;
    $[45] = t16;
    $[46] = t4;
    $[47] = t5;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  return t17;
};